import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from '../api.service'
import Swal from 'sweetalert2';

@Component({
    selector: 'app-generate-images',
    templateUrl: './generate-images.component.html',
    styleUrls: ['./generate-images.component.scss']
})

export class GenerateImagesComponent implements OnInit, AfterViewInit, OnDestroy {

    userID = 0
	courseID = 0
	courseUnits: any[] = []
	selectedUnit = -1
	unitLessons: any[] = []
	selectedLesson = -1
	lessonHeadings: any[] = []
	selectedHeading = -1
    
    model = ''
    // prompt = 'People wearing white robes and black masks boarding a spaceship during a sunset with a forest in the background seen from very far away'
    prompt = ''
    number = 1
    size = ''
    destination = ''
    images: any[] = []
    selectedImages: any[] = []

    imageGenerating = false
    imageGenerateSuccess = false
    imageGenerateError = false
    imageGenerateErrorMessage = ''
    imageSaving = false
    imageSaveSuccess = false
    imageSaveError = false

    showCourseSub = new Subscription
    generateImagesSub = new Subscription
    saveGeneratedImagesSub = new Subscription

    constructor(private dataService: ApiService, private actRoute: ActivatedRoute) { }

    ngOnInit(): void {
        this.userID = this.dataService.getUserID()
        this.courseID = +this.actRoute.snapshot.paramMap.get('id')!
    }

    ngAfterViewInit(): void {
        this.showCourseSub = this.dataService.getCourse(this.courseID, this.userID)
		.subscribe(
			course => {
				this.courseUnits = course.units
			},
			error => {
				console.log(error)
			}
		)
    }

    ngOnDestroy(): void {
        this.showCourseSub?.unsubscribe()
        this.generateImagesSub?.unsubscribe()
        this.saveGeneratedImagesSub?.unsubscribe()
    }

    selectUnit(unitId: number): void {
		this.unitLessons = this.courseUnits?.find((unit) => {
			return +unitId === +unit.id
		})?.lessons!

		this.selectedLesson = -1
		this.selectedHeading = -1
		this.lessonHeadings = []

		if (this.unitLessons?.length === 1) {
			this.selectLesson(this.unitLessons[0].id)
		}
	}

	selectLesson(lessonId: number): void {
		this.lessonHeadings = this.unitLessons?.find((lesson) => {
			return +lessonId === +lesson.id
		})?.headings!

		this.selectedLesson = +lessonId
		this.selectedHeading = -1

		if (this.lessonHeadings?.length === 1) {
			this.selectedHeading = this.lessonHeadings[0].id
		}
	}

    setState(state: 'generating' | 'generate-success' | 'generate-error' | 'saving' | 'save-success' | 'save-error') {
        if (state.includes('gen')) {
            this.imageSaving = false
            this.imageSaveSuccess = false
            this.imageSaveError = false
        } else if (state.includes('sav')) {
            // this.imageGenerating = false
            // this.imageGenerateSuccess = false
            // this.imageGenerateError = false
        }
        
        if (state == 'generating') {
            this.imageGenerating = true
            this.imageGenerateSuccess = false
            this.imageGenerateError = false
            this.destination = ''
            this.selectedUnit = -1
            this.selectedLesson = -1
        } else if (state == 'generate-success') {
            this.imageGenerating = false
            this.imageGenerateSuccess = true
            this.imageGenerateError = false
        } else if (state == 'generate-error') {
            this.imageGenerating = false
            this.imageGenerateSuccess = false
            this.imageGenerateError = true
        } else if (state == 'saving') {
            this.imageSaving = true
            this.imageSaveSuccess = false
            this.imageSaveError = false
        } else if (state == 'save-success') {
            this.imageSaving = false
            this.imageSaveSuccess = true
            this.imageSaveError = false
        } else if (state == 'save-error') {
            this.imageSaving = false
            this.imageSaveSuccess = false
            this.imageSaveError = true
        }
    }
    
    generateImages() {
        console.log(this.model)
        // console.log(this.prompt)
        // console.log(this.number)
        console.log(this.size)

        if (this.model == '') {
            Swal.fire('Error', 'Por favor, seleccione un modelo.', 'error')
            return
        }

        if (this.prompt == '') {
            Swal.fire('Error', 'Por favor, escriba una descripción de la imagen que desea generar.', 'error')
            return
        }

        if (this.model.includes('dall-e') && this.size == '') {
            Swal.fire('Error', 'Por favor, seleccione un tamaño para las imágenes.', 'error')
            return
        }

        if (this.model != 'dall-e-3' && this.number < 1) {
            Swal.fire('Error', 'Por favor, seleccione un número mayor que 1.', 'error')
            return
        }

        this.setState('generating')

        this.images = []
        this.selectedImages = []
        this.dataService.generateImages(this.courseID, this.model, this.prompt, this.number, this.size)
        .subscribe(
            data => {
                console.log(data)
                if (data != null && data.error == null) {
                    this.images = data
    
                    if (this.images.length > 0) {
                        this.setState('generate-success')
    
                        if (this.images.length == 1) {
                            this.selectImage(this.images[0])
                        }
                    } else {
                        this.setState('generate-error')
                    }
                } else {
                    this.imageGenerateErrorMessage = data.error.message
                    this.setState('generate-error')
                }
            },
            error => {
                console.log(error)
                // this.imageGenerateErrorMessage = error.message
                this.setState('generate-error')
            }
        )
    }

    imageIsSelected(image: string) {
        let index = this.selectedImages.findIndex((selectedImage) => {
			return image === selectedImage
		})

		return index
    }

    selectImage(image: string) {
        let index = this.imageIsSelected(image)

		if (index > -1) {
			this.selectedImages.splice(index, 1)
		} else {
			this.selectedImages.push(image)
		}
    }

    saveImages() {
        // console.log(this.destination)
        // console.log(this.selectedUnit)
        // console.log(this.selectedLesson)
        // console.log(this.selectedHeading)

        if (this.destination == 'lesson' && this.selectedLesson == -1) {
            Swal.fire('Error', 'Por favor, seleccione una lección.', 'error')
            return
        }

        if (this.destination == 'heading' && this.selectedHeading == -1) {
            Swal.fire('Error', 'Por favor, seleccione un enunciado.', 'error')
            return
        }

        this.setState('saving')

        this.saveGeneratedImagesSub = this.dataService.saveGeneratedImages(this.courseID, this.destination, this.selectedLesson, this.selectedHeading, this.selectedImages)
        .subscribe(
            data => {
                console.log(data)
                this.setState('save-success')
            },
            error => {
                console.log(error)
                this.setState('save-error')
            },
        )
    }
}
